import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { RsIcon } from './icons'

export default function UpgradeModal({ open, onClose, onUpgrade, message, upgradeTo = '/payment' }) {
  const navigate = useNavigate()
  const { user } = useAuth()
  if (!open) return null

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade()
      return
    }
    const target = user ? upgradeTo : '/pricing'
    navigate(target)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="upgrade-pricing-card max-w-md w-full" style={{ padding: 32 }}>
        <div className="flex justify-between items-start mb-4">
          <div>
            <div style={{ marginBottom: 8 }}><RsIcon name="lock" size="xl" /></div>
            <h3 style={{ fontSize: 20, fontWeight: 800, color: '#0f3d8a' }}>Upgrade Required</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: 'none',
              background: '#f5f7fa',
              width: 32,
              height: 32,
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 18,
              color: '#909399',
            }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <p style={{ fontSize: 14, color: '#606266', lineHeight: 1.65, marginBottom: 24 }}>
          {message ||
            'This feature requires an active membership. Upgrade to unlock chat, deal posting, and premium tools.'}
        </p>
        <button
          type="button"
          onClick={handleUpgrade}
          className="upgrade-checkout-btn"
          style={{ width: '100%', marginTop: 0 }}
        >
          View Plans →
        </button>
      </div>
    </div>
  )
}
